import React from "react"
import { Query } from "react-apollo"
import ApolloQueryHandler from "../../shared/apolloQueryHandler"
import Button from "../../components/Button"
import AddDevice from "../../components/AddDevice"
import qs from "qs"
import { colorLogo } from "../../shared/images"

import REGISTER_DEVICE_DATA from "../../graphql/registerDeviceData.graphql"

import "./registerDevice.scss"

class RegisterDevice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentStep: 0,
      redirect: false,
    }
  }

  static getDerivedStateFromProps = (props, state) => {
    let query = qs.parse(props.location.search, { ignoreQueryPrefix: true })
    let currentStep = query.step ? parseInt(query.step) : 1
    if (props.data.viewer) {
      if (props.data.viewer.isDeviceAuthenticated) {
        return { ...state, redirect: true }
      } else if (
        (props.data.viewer.devices || []).length >=
        props.data.viewer.deviceLimit
      ) {
        return { ...state, currentStep: 2 }
      }

      return {
        ...state,
        currentStep: Math.max(currentStep, 1),
      }
    }

    return state
  }

  componentDidMount() {
    if (this.props.data.viewer.isDeviceAuthenticated) {
      window.location.replace("/")
    }
  }

  componentDidUpdate() {
    if (this.state.redirect) {
      const pathname =
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.from &&
        this.props.location.state.from.pathname

      const path = pathname || "/"
      window.location.replace(path)
    }
  }

  submitDevice = () => {
    this.setState({ redirect: true })
  }

  _renderFormDetail = () => {
    switch (this.state.currentStep) {
      case 1:
        return <AddDevice onSubmit={this.submitDevice} />
      case 2:
        return (
          <Button
            fullWidth
            classes={["dark-fill", "small-caps"]}
            action={() => this.props.history.push("/account")}
            text="Manage devices"
          />
        )
      default:
        return null
    }
  }

  _renderFormMessage = () => {
    switch (this.state.currentStep) {
      case 1:
        return (
          <div className="step-description">
            <h3>NAME YOUR DEVICE</h3>
            <p>Enter a name to remember this device.</p>
          </div>
        )
      case 2:
        return (
          <div className="step-description">
            <h3>NO MORE DEVICES AVAILABLE</h3>
            <p>
              You have reached your device limit! Go to your account to manage
              your registered devices:
            </p>
          </div>
        )
      default:
        return null
    }
  }

  render() {
    return (
      <div id="ResetDevice" data-cy="register-device-form">
        <div className="form-container">
          <div className="logo">
            <img src={colorLogo} alt="ETR" className="logo-md" />
          </div>
          {this._renderFormMessage()}
          {this._renderFormDetail()}
        </div>
      </div>
    )
  }
}

const RegisterDeviceWithData = (componentProps) => (
  <Query query={REGISTER_DEVICE_DATA} fetchPolicy="network-only">
    {(queryProps) => (
      <ApolloQueryHandler {...componentProps} {...queryProps}>
        {(props) => <RegisterDevice {...props} />}
      </ApolloQueryHandler>
    )}
  </Query>
)

export default RegisterDeviceWithData
